import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { ConfigurePolicyModalComponent } from './configure-policy-modal/configure-policy-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Module } from '../../models/common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-policy-configurator',
  templateUrl: './policy-configurator.component.html',
  styleUrls: ['./policy-configurator.component.scss']
})
export class PolicyConfiguratorComponent implements OnInit {


  gridApi: GridApi;
  collapesedOrNot: boolean = false;
  columnDefs;
  operations;
  rowData;
  advanceSearch;
  selectedRow;
  DocumentSearch: UntypedFormGroup;
  modulelist: Module[] = [];
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private modalService: NgbModal
  ) {

  }

  ngOnInit() {
    this.DocumentSearch = new UntypedFormGroup({
      MODULE_ID: new UntypedFormControl(),
    });

    // this.criteriaService.getPolicyConfiguratorCriteria().subscribe(criteria => {
    //   this.columnDefs = criteria.columnDefs;
    //   this.advanceSearch = criteria.advanceSearch;
    //   this.operations = criteria.operations.map(operation => {
    //     return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    //   });
    // })
    this.setSummary("-1");
    this.getModulesList();
  }

  getModulesList(): void {
    this.summaryService.getModuleByOrgId().subscribe((result) => {
      this.modulelist = result;

    });
  }
  setSummary(module) {
    this.summaryService.getPolicyConfig(module).subscribe(summary => {
      this.rowData = summary;
    });

  }

  setSummarySearch() {
    this.setSummary("-1");
  }

  SearchClear() {
    this.DocumentSearch.reset();
  }

  AdvanceSearch() {
    var poli = this.DocumentSearch.value;
    this.setSummary(poli.MODULE_ID);
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

 onRowDoubleClicked(event) {
  //  const modelRef=this['self'].modalService.open(PolicyConfiguratorModalComponent, {
  //   backdrop: false,
  //   keyboard: false,
  //   windowClass:'modal-vlg right modal-right',
  //   animation: true
  // });
  // modelRef.componentInstance.Content={
  //   heading: 'View',
  //   content: { id: this['self'].selectedRow['ID'] }
  // }
  }

 edit() {
  // //debugger;
  // const modelRef = this['self'].modalService.open(PolicyConfiguratorModalComponent, {
  //   backdrop: false,
  //   keyboard: false,
  //   //ignoreBackdropClick: true,
  //   windowClass:'modal-llg right modal-right',
  //   animation: true,
  // });
  //   modelRef.componentInstance.Content= {
  //     heading: 'Edit',
  //     content: { id: this['self'].selectedRow['ID'] }
  //   }

  }

  add() {
    // const modelRef = this['self'].modalService.open(PolicyConfiguratorModalComponent, {
    //   backdrop: false,
    //   keyboard: false,
    //   //ignoreBackdropClick: true,
    //   windowClass:'modal-llg right modal-right',
    //   animation: true,
    // });
    // modelRef.componentInstance.Content= {
    //     heading: 'New',
    //     content: null
    //   }

    }
    configurepolicy() {
      const modelRef = this['self'].modalService.open(ConfigurePolicyModalComponent, {
        backdrop: false,
        keyboard: false,
       // ignoreBackdropClick: true,
       windowClass:'modal-llg right modal-right',
       animation: true,
      });
      modelRef.componentInstance.Content= {
          heading: '',
          content: null,
          policyid: this['self'].selectedRow['ID']
        }

      }


  delete() {
    this["self"].modalRef = this["self"].modalService.open(DeleteBoxComponent,{backdrop: false});
  }

  active() {
      this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent, {data:{heading:'Active',content: { heading: '', description: 'Selected Records has been made Active.'}}});
  }

  inactive() {
      this['self'].modalRef = this['self'].modalService.open(MessageBoxComponent, {data:{heading:'Inactive',content: { heading: '', description: 'Selected Records has been made Inactive.'}}});
  }



}
